import BoxTitle from "../../../TEMPLATE/components/box/title/BoxTitle";
import { Fragment, useCallback, useContext, useEffect, useState } from "react";
import { baseUrl } from "../../hardCodeData/DATA";
import img from "./../../assets/parking_icon.png";

import DonutChart from "../../../TEMPLATE/components/charts/DonutChart";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import {
  ParkingDataContext,
  PublicParkingDataContext,
} from "../../../TEMPLATE/hooks/context";

const Parking = ({ id, typeId }) => {
  const { t } = useTranslation();
  const currentLanguageCode = Cookies.get("i18next") || "el";

  const { parkingData } = useContext(ParkingDataContext);
  const { publicParkingData } = useContext(PublicParkingDataContext);

  const [chartSourceData, setChartSourceData] = useState([]);
  const controller = new AbortController();

  useEffect(() => {
    let availablePublicSpots = 0;
    let totalPublicSpots = 0;
    let occupiedSpots = 0;
    let totalSpots = 0;

    if (typeId === "36") {
      publicParkingData?.forEach((item) => {
        totalPublicSpots += item.total_slots;
        availablePublicSpots += item.available_slots;
      });
    } else {
      parkingData?.forEach((item) => {
        totalSpots += item.Places;
        occupiedSpots += item.PlacesOccupied;
      });
    }

    if (parkingData || publicParkingData) {
      const sourceData = [
        {
          item: t("parking.vacant"),
          count:
            typeId === "24" ? totalSpots - occupiedSpots : availablePublicSpots,
        },
        {
          item: t("parking.occupied"),
          count:
            typeId === "24"
              ? occupiedSpots
              : totalPublicSpots - availablePublicSpots,
        },
      ];

      setChartSourceData(sourceData);
    }
  }, [parkingData, publicParkingData, currentLanguageCode]);

  return (
    <Fragment>
      <BoxTitle
        icon={"im im-icon-Car-2"}
        title={typeId === "36" ? t("parking.publicTitle") : t("parking.title")}
        infoContext={
          typeId === "36" ? t("parking.publicTooltip") : t("parking.tooltip")
        }
        img={img}
        link={`/map?typeId=${typeId}`}
        element={
          <i
            id="draggable"
            className="im im-icon-Double-Tap"
            style={{ fontSize: "32px", minWidth: "32px", cursor: "pointer" }}
          />
        }
      />
      <h1
        style={{
          textAlign: "center",
          marginBottom: 10,
          fontSize: 16,
          lineHeight: 1,
          fontWeight: 400,
          color: "white",
        }}
      >
        {t("cityName")}
      </h1>
      <DonutChart data={chartSourceData} lang={currentLanguageCode} />
    </Fragment>
  );
};

export default Parking;
